import { getClassName } from 'common/utils';
import React from 'react';

interface SeekbarPointProps {
  percentage: number;
  active?: boolean;
}
function SeekbarPoint(props: SeekbarPointProps) {
  return (
    <div
      data-test-id="seekbar-point"
      data-active={props.active}
      data-value={props.percentage}
      className={getClassName('seekbar-point', { focused: props.active })}
      style={{ left: `${props.percentage}%` }}
    />
  );
}

export default React.memo(SeekbarPoint);
